import type { Map as ImmutableMap } from 'immutable';
import React, { useEffect } from 'react';

import { UserData } from 'shared/models/user';

import { fetchUsers } from '../actions';
import { useReduxDispatch, useReduxState } from '../hooks/use-redux';

interface InjectedProps {
    users: ImmutableMap<string, UserData>;
}

type ReactComp<T> = React.ComponentType<T>;

export function withUsers<P>(WrappedComponent: ReactComp<P & InjectedProps>): React.ComponentType<P> {
    const WithUsersWrapper: React.FC<P> = (props) => {
        const users = useReduxState((state) => state.users);
        const listsState = useReduxState((state) => state.listsState);
        const dispatch = useReduxDispatch();

        useEffect(() => {
            if (!listsState.get('users')) {
                dispatch(fetchUsers());
            }
        }, [dispatch, listsState]);

        if (!listsState.get('users')) {
            return null;
        }

        return <WrappedComponent {...(props as P)} users={users} />;
    };

    WithUsersWrapper.displayName = `WithUsers(${WrappedComponent.displayName || WrappedComponent.name})`;

    return WithUsersWrapper;
}
